import React from 'react';
import { useColors } from '../theme';
import { T } from './Text';

export function EmptyNote({ children }: { children: React.ReactNode }) {
  const colors = useColors();
  return (
    <T
      size={13}
      color={colors.textFaint}
      style={{ paddingVertical: 20, textAlign: 'center', lineHeight: 20 }}
    >
      {children}
    </T>
  );
}
